import { render, staticRenderFns } from "./DasherDetailsReport.vue?vue&type=template&id=3b577131&scoped=true"
import script from "./DasherDetailsReport.vue?vue&type=script&lang=js"
export * from "./DasherDetailsReport.vue?vue&type=script&lang=js"
import style0 from "./DasherDetailsReport.vue?vue&type=style&index=0&id=3b577131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b577131",
  null
  
)

export default component.exports